/**
 * Agency Logos Form Logic
 *
 * Views: agencies/partials/logo-form
 */

if ($('#app-agency-logo-form').length > 0) {
    $(document).ready(function () {
        var Cropper = window.Cropper;
        var URL = window.URL || window.webkitURL;
        var uploadedImageURL;

        var options = {
            'horizontal': {
                aspectRatio: 16 / 9,
                viewMode: 0,
                dragMode: 'move',
                autoCropArea: 1
            },
            'vertical': {
                aspectRatio: 9 / 16,
                viewMode: 0,
                dragMode: 'move',
                autoCropArea: 1
            },
            'square': {
                aspectRatio: 1,
                viewMode: 0,
                dragMode: 'move',
                autoCropArea: 1
            }
        };

        var step = 1;

        var croppers = {
            'horizontal': new Cropper(document.getElementById('horizontal-logo'), options.horizontal),
            'vertical': new Cropper(document.getElementById('vertical-logo'), options.vertical),
            'square': new Cropper(document.getElementById('square-logo'), options.square)
        };
        var croppers_additional;

        $('#sec2logos').on('click', function (){
            console.log('refresh sec2: ');
            $('body').css('zoom','101%');
            $('body').css('zoom','1.01');
            $('body').css('-moz-transform', 'scale(1.01, 1.01)');

            croppers = {
                'horizontal': document.getElementById('horizontal-logo').cropper,
                'vertical': document.getElementById('vertical-logo').cropper,
                'square': document.getElementById('square-logo').cropper,
            };
            // croppers['horizontal'].options = {
            //     aspectRatio: 16 / 9,
            //     viewMode: 0,
            //     dragMode: 'move',
            //     autoCropArea: 1
            // };

            // Cropper = window.Cropper;
            // URL = window.URL || window.webkitURL;
            // uploadedImageURL;
            //
            // options = {
            //     'horizontal': {
            //         aspectRatio: 16 / 9,
            //         viewMode: 0,
            //         dragMode: 'move',
            //         autoCropArea: 1
            //     },
            //     'vertical': {
            //         aspectRatio: 9 / 16,
            //         viewMode: 0,
            //         dragMode: 'move',
            //         autoCropArea: 1
            //     },
            //     'square': {
            //         aspectRatio: 1,
            //         viewMode: 0,
            //         dragMode: 'move',
            //         autoCropArea: 1
            //     }
            // };
            //
            // if(croppers){
            //     if(croppers['horizontal'])
            //         croppers['horizontal'].destroy();
            //     if(croppers['vertical'])
            //         croppers['vertical'].destroy();
            //     if(croppers['square'])
            //         croppers['square'].destroy();
            // }
            //
            // croppers = {
            //     'horizontal': new Cropper(document.getElementById('horizontal-logo'), options.horizontal),
            //     'vertical': new Cropper(document.getElementById('vertical-logo'), options.vertical),
            //     'square': new Cropper(document.getElementById('square-logo'), options.square)
            // };
            //
            // $('.cropper-image').each(function (index, value) {
            //     if ($(value).hasClass('empty')) {
            //         $(value).closest('.logo-container')
            //             .find('button[data-method="zoom-out"], button[data-method="zoom-in"], button[data-method="save"], button[data-method="preview"], button[data-method="default"]')
            //             .attr('disabled', 'disabled');
            //     }
            // });
        })

        $('.cropper-image').each(function (index, value) {
            if ($(value).hasClass('empty')) {
                $(value).closest('.logo-container')
                    .find('button[data-method="zoom-out"], button[data-method="zoom-in"], button[data-method="save"], button[data-method="preview"], button[data-method="default"]')
                    .attr('disabled', 'disabled');
            }
        });

        $('.logo-upload').on('change', function () {
            var files = this.files;
            var file;

            var container = $(this).closest('.logo-container');
            var type = container.attr('data-id');
            var cropper = croppers[type];


            if (cropper && files && files.length) {
                file = files[0];

                if (/^image\/\w+/.test(file.type)) {
                    if (uploadedImageURL) {
                        URL.revokeObjectURL(uploadedImageURL);
                    }

                    var image = document.getElementById(container.find('img').attr('id'));

                    image.src = uploadedImageURL = URL.createObjectURL(file);

                    cropper.destroy();
                    croppers[type] = new Cropper(image, options[type]);
                    container.find('img').val(null);

                    container.find('button[data-method="zoom-out"], button[data-method="zoom-in"], button[data-method="save"],button[data-method="default"], button[data-method="preview"]')
                        .attr('disabled', null);
                    container.find('image').removeClass('empty');
                } else {
                    global_notification('warning', 'You may only upload the following image types: JPG, PNG, GIF.');
                }
            }
        });

        $('[data-method="zoom-in"]').on('click', function () {
            container = $(this).closest('.logo-container');
            cropper = croppers[container.attr('data-id')];
            cropper.zoom(0.1);
        });

        $('[data-method="zoom-out"]').on('click', function () {
            container = $(this).closest('.logo-container');
            cropper = croppers[container.attr('data-id')];
            cropper.zoom(-0.1);
        });

        $('[data-method="preview"]').on('click', function () {
            container = $(this).closest('.logo-container');
            cropper = croppers[container.attr('data-id')];
            data = cropper.getCroppedCanvas({
                width: 480,
                height: 270,
                fillColor: '#ffffff'
            });

            $('#getCroppedCanvasModal').modal().find('.modal-body').html(data);

        });
        $('[data-method="default"]').on('click', function () {
           if($('#check-default').val()==1){
               $('#check-default').val(0);
               $(this).attr('class', 'btn btn-default');
           }
           else{
               $('#check-default').val(1);
               $(this).attr('class', 'btn btn-warning');
           }
        });

        $('[data-method="default-addtional"]').on('click', function () {
            if($(this).val()==1) {
                $(this).attr('class', 'btn btn-default');
                $(this).val(0);
                $('#check-default-add').val(0);
            }
            else{
                $(this).val(1);
                $('#check-default-add').val(1);
                $(this).attr('class', 'btn btn-warning');
            }
        });

        $('[data-method="delete"]').on('click', function () {
            var container = $(this).closest('.logo-container');
            console.log('container: ', container);
            var cropper = croppers[container.attr('data-id')];
            console.log('cropper: ', cropper);
            var type = container.attr('data-id');
            console.log('type: ', type);
            console.log('cropper.getCroppedCanvas(): ', cropper.getCroppedCanvas());

            cropper.getCroppedCanvas().toBlob(function (blob) {
                var formData = new FormData();
                formData.append('type', type);
                $.ajax({
                    url: '/agency/logo/delete/',
                    method: "POST",
                    data: formData,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    processData: false,
                    contentType: false,
                    success: function (data) {
                        container.find('img').attr('src', "");
                        var image = document.getElementById(container.find('img').attr('id'));

                        global_notification('success', 'Your logo has been deleted. You may need to refresh your browser to see changes.');

                        cropper.destroy();
                        container.find('img').val(null);
                    },
                    error: function (xhr) {
                        ajax_error();
                        debug(xhr.responseText);
                    }
                });
            });
        });

        $('[data-method="save"]').on('click', function () {
            var container = $(this).closest('.logo-container');
            var cropper = croppers[container.attr('data-id')];
            var type = container.attr('data-id');
            var check = $('#check-default').val();

            cropper.getCroppedCanvas().toBlob(function (blob) {
                var formData = new FormData();
                formData.append('logo', blob);
                formData.append('type', type);
                formData.append('check', check);

                $.ajax({
                    url: '/agency/logo/store/',
                    method: "POST",
                    data: formData,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    processData: false,
                    contentType: false,
                    success: function (data) {
                        container.find('img').attr('src', data['path']);
                        var image = document.getElementById(container.find('img').attr('id'));
                        if (check == 0) {
                            $('[data-method="default"]').attr('class', 'btn btn-default');
                            $('[data-method="default"]').val(0);
                            $('#check-default-add').val(0);
                        }
                        else
                            initializeLogosTable();

                        global_notification('success', 'Your logo has been saved. You may need to refresh your browser to see changes.');

                        cropper.destroy();
                        croppers[type] = new Cropper(image, options[type]);
                        container.find('img').val(null);
                    },
                    error: function (xhr) {
                        ajax_error();
                        debug(xhr.responseText);
                    }
                });
            });
        });

        //Additional Logos Table

          initializeLogosTable();
            function initializeLogosTable() {
                $('#app-logo-list-table').DataTable({
                        ajax: {
                            url: '/additional/logos/table/initialize',
                            dataSrc: 'data'
                        },
                        columns: [
                            {data: 'image'},//0
                            {data: 'type'},//1
                            {data: 'description'},//2
                            {data: 'created_at'},//3
                            {data: 'id'},//4,
                            {data: 'avatar_background'},//5
                        ],
                        pageLength: user_entries,
                        destroy: true,
                        "columnDefs": [
                            {
                                "targets": 5,
                                "visible": false,
                                "searchable": false,
                            },
                            {
                            "targets": 4,
                            "orderable": false,
                            "createdCell": function (td, cellData, rowData, row, col) {
                                var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                                            '<a href="javascript:void(0)" data-id="'+cellData+'" role="button" class="btn btn-danger btn-sm delete_addional_logo">' +
                                            '<i class="fa fa-trash-o"></i> Delete' +
                                            '</a>' ;
                                  if(rowData.avatar_background==1)
                                      var but_class='btn btn-warning btn-sm';
                                  else
                                      var but_class='btn btn-default btn-sm';
                                  if(rowData.type=='horizontal') {
                                      html += '<a href="javascript:void(0)" data-value="' + rowData.avatar_background + '" data-id="' + cellData + '" role="button" class="' + but_class + ' avatar_back_click"  data-original-title="Check as Avatar background"> ' +
                                          ' <span class="docs-tooltip" data-toggle="tooltip" title=""' +
                                          '                                      data-original-title="Check as Avatar background"><i class="fa fa-check"></i></span>' +
                                          '</a>';
                                  }
                                    html+='</div>';

                                $(td).html(html);
                            }
                        }],

                    });

            }


        //Additional Logos
        $('#app-logo-list-table').on('click', '.avatar_back_click', function () {
            var id= $(this).attr('data-id');
            var value= $(this).attr('data-value');
            swal({
                    title: "Warning",
                    text: "Are you sure to Check as Avatar Background?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        show_loader();
                        $.ajax({
                            url: '/logos/additional_logos/check/avatar_backgorund/' + id+ '/' + value,
                            type:'GET',
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                if (value == 0) {
                                    $('[data-method="default"]').attr('class', 'btn btn-default');
                                    $('[data-method="default"]').val(0);
                                    $('#check-default-add').val(0);
                                }
                                hide_loader();
                                global_notification('success', 'Logo checked as Avatar background...');
                                initializeLogosTable();
                            },
                            error: function (xhr) {
                                ajax_error();
                                debug(xhr.responseText);
                                hide_loader();
                            }
                        });

                    }
                });
        });
        $('#add_logo_list').on('click', function () {
            $('input:checkbox[name=logo_type_additional]:checked').prop('checked', false);
            $('input:radio[name=logo_type_additional]:checked').prop('checked', false);
            $('#div_to_display').hide();
            $('.logo-container-desc').hide();
            $('#check-default-add').val(0);
            $('#addAddioniotaltLogos').modal('show');
        });

        $('.div-additional-logos-type-container input[type="radio"]').on('change', function () {
            var type= $(this).val();
            if(typeof croppers_additional !=='undefined' && croppers_additional!='') {
                var cropper = croppers_additional;
                var container = $('.logo-container');
                cropper.destroy();
                container.find('img').val(null);
            }
            $('#div_to_display').show();
            $('.logo-container-desc').show();

            if(type=='horizontal') {
                croppers_additional = new Cropper(document.getElementById('square-logo-additional'), options.horizontal);
                $('#change_label').html('Horizontal');
                $('#hide_button_def').show();
            }
            else if(type=='square') {
                croppers_additional = new Cropper(document.getElementById('square-logo-additional'), options.square);
                $('#change_label').html('Square');
                $('#hide_button_def').hide();
            }
            else {
                croppers_additional = new Cropper(document.getElementById('square-logo-additional'), options.vertical);
                $('#change_label').html('Vertical');
                $('#hide_button_def').hide();
            }

        });
        $('.logo-upload-additional').on('change', function () {

            var files = this.files;
            var file;

            var container = $(this).closest('.logo-container');
            var type =  $("input:radio[name=logo_type_additional]:checked").attr('value');
            var cropper = croppers_additional;


            if (cropper && files && files.length) {
                file = files[0];

                if (/^image\/\w+/.test(file.type)) {
                    if (uploadedImageURL) {
                        URL.revokeObjectURL(uploadedImageURL);
                    }

                    var image = document.getElementById(container.find('img').attr('id'));

                    image.src = uploadedImageURL = URL.createObjectURL(file);

                    cropper.destroy();
                    croppers_additional = new Cropper(image, options[type]);
                    container.find('img').val(null);

                    container.find('button[data-method="zoom-out"], button[data-method="zoom-in"], button[data-method="save"], button[data-method="preview"]')
                        .attr('disabled', null);
                    container.find('image').removeClass('empty');
                } else {
                    global_notification('warning', 'You may only upload the following image types: JPG, PNG, GIF.');
                }
            }
        });

        $('[data-method="zoom-in-add"]').on('click', function () {
            container = $(this).closest('.logo-container');
            cropper = croppers_additional;
            cropper.zoom(0.1);
        });

        $('[data-method="zoom-out-add"]').on('click', function () {
            container = $(this).closest('.logo-container');
            cropper = croppers_additional
            cropper.zoom(-0.1);
        });

        $('[data-method="preview-add"]').on('click', function () {
            container = $(this).closest('.logo-container');
            cropper = croppers_additional
            data = cropper.getCroppedCanvas({
                width: 480,
                height: 270,
                fillColor: '#ffffff'
            });

            $('#getCroppedCanvasModalAdditional').modal().find('.modal-body').html(data);

        });

        $('#save_aditional_logo').on('click', function () {
            var cropper = croppers_additional;
            var type = $("input:radio[name=logo_type_additional]:checked").attr('value');
            var description = $('#lodo_description').val();

            if(typeof type!=='undefined' || type!='' || type!==null){
                if( $('#square-logo-additional').attr('src')== null ||  $('#square-logo-additional').attr('src')=='' || $('#square-logo-additional').attr('src')=='undefined')
                    global_notification('warning', 'Logo field is required...');
                else if(typeof description == 'undefined' || description == '')
                    global_notification('warning', 'Description field is required...');
                else {
                    $('#addAddioniotaltLogos').modal('hide');
                    show_loader();
                    cropper.getCroppedCanvas().toBlob(function (blob) {
                        var formData = new FormData();
                        formData.append('logo', blob);
                        formData.append('type', type);
                        formData.append('description', description);
                        formData.append('check',  $('#check-default-add').val());
                        $.ajax({
                            url: '/agency/logo/additional/store/',
                            method: "POST",
                            data: formData,
                            headers: {
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            },
                            processData: false,
                            contentType: false,
                            success: function (data) {
                                if ( $('#check-default-add').val() == 1) {
                                    $('[data-method="default"]').attr('class', 'btn btn-default');
                                    $('[data-method="default"]').val(0);
                                    $('#check-default-add').val(0);
                                }
                                hide_loader();
                                initializeLogosTable();
                                global_notification('success', 'Your logo has been saved...');

                            },
                            error: function (xhr) {
                                hide_loader();
                                ajax_error();
                                debug(xhr.responseText);

                            }
                        });
                    });
                }
            }
            else
                global_notification('warning', 'Please select a type...');
        });
        $('#app-logo-list-table').on('click', '.delete_addional_logo', function () {
            var id= $(this).attr('data-id');
            show_loader();
            $.ajax({
                type: 'GET',
                url: '/agency/additional/logos/delete/' + id,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    hide_loader();
                    initializeLogosTable();
                    global_notification('success', 'Logo deleted...');
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);

                }
            });
        });

    });

}
